import React from "react";

// Redux
import { useSelector } from "react-redux";

// React Query
import { useQuery } from "@tanstack/react-query";

// API
import { getCustomerEngagementTrail } from "@DataPages/api/customerEngagementTrail";

//Components
import EmptyBody from "@Layouts/components/Basics/EmptyBody";
import TableLoader from "@Layouts/components/Skeletons/TableLoader";
import CustomerEngagementTrailTable from "@DataPages/components/CustomerEngagementTrail/Tables/CustomerEngagementTrailTable";

// MUI
import { Grid, Skeleton, Typography } from "@mui/material";

// Assets
import empty from "@/assets/images/commons/empty.png";
import emptyTable from "@/assets/images/commons/empty_table.png";

export default function CustomerEngagementTrailBody(props) {
	const subscriptionId = React.useRef(null);
	const location = useSelector((state) => state.location.location);

	//Queries
	const { data: customerEngagementTrail, isLoading: isLoadingCustomerEngagementTrail } = useQuery({
		queryKey: [props.queryIdentifier, location?.locationId, props.selected?._id],
		queryFn: async () => getCustomerEngagementTrail(location.locationId, props.selected._id),
		enabled: !!location?.locationId && !!props.selected?._id,
		staleTime: Infinity,
	});

	React.useEffect(() => {
		if (props.selected) {
			subscriptionId.current = props.selected._id;
		}

		return () => {
			subscriptionId.current = null;
		};
	}, [props, location]);

	return (
		<Grid container alignContent={"flex-start"} sx={{ height: "100%" }}>
			<Grid item xs={12}>
				{isLoadingCustomerEngagementTrail ? (
					<Skeleton variant="rectangular" height={25} width={350} sx={{ borderRadius: "6px" }} />
				) : (
					<React.Fragment>
						{props.selected && (
							<Typography className={"page-title !mb-[8px]"} sx={{ lineHeight: "1.2" }}>
								{`${props.selected?.title} Engagement Trail`}
							</Typography>
						)}
					</React.Fragment>
				)}
			</Grid>

			<Grid container item alignContent={"space-between"} sx={{ height: "100%" }}>
				<Grid item xs={12}>
					{Boolean(isLoadingCustomerEngagementTrail) ? (
						<Grid item xs={12} mt={1}>
							<TableLoader toolbar buttons={3} content rows={5} multiTitles={5} />
						</Grid>
					) : (
						Boolean(customerEngagementTrail?.engagementInfo?.length) && (
							<CustomerEngagementTrailTable data={customerEngagementTrail?.engagementInfo || []} />
						)
					)}
				</Grid>
				{!Boolean(customerEngagementTrail) && !Boolean(isLoadingCustomerEngagementTrail) && (
					<EmptyBody
						image={props?.selected ? emptyTable : empty}
						title={
							props.selected
								? "No Customer Engagement Trail for this month"
								: "Select a month to view their Customer Engagement Trail"
						}
						bodyHeight={"480px"}
						sx={{
							boxShadow: "none !important",
						}}
					/>
				)}
			</Grid>
		</Grid>
	);
}
